import { axios } from '../axios';

export default async function unassignService(ordersIds) {
  const body = {
    ordersIds,
  };

  return axios.put('/unassign', body);
}
